import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FiltersPagination from "../../../components/elements/FiltersPagination";
import DataTableElement from "../../../components/elements/DataTableElement";
import Columns from "./Columns";
import { paymentsResource } from "../../../helpers/configRoutes/backend_helper";

const Accounting = () => {
    const navigate = useNavigate();

    const [filters, setFilters] = useState({
        endDate: "",
        startDate: "",
        search: "",
        from: 0,
        to: 0,
        page: 1,
    });
    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading payments...",
    });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [data, setData] = useState([]);

    useEffect(() => {
        const getPayments = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));
            const response = await paymentsResource("get", { params: filters });
            setData(response.payments || []);
            setMeta(response.meta || { total: 0, current_page: 0 });
            setTableLoad((prev) => ({ ...prev, show: false }));
        };
        getPayments();
    }, [filters]);

    const cols = Columns(navigate);

    return (
        <div className="min-h-screen bg-cs-bg-alt py-8 px-4">
            <div className="max-w-6xl mx-auto space-y-4">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.18em] text-cs-muted">
                            Billing center
                        </p>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Accounting
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Review all payments, invoices and related transactions.
                        </p>
                    </div>
                    <div className="flex flex-col items-start md:items-end text-[9px] text-cs-muted">
                        <span>
                            Total records:{" "}
                            <span className="font-semibold text-cs-primary-dark">
                                {meta.total || 0}
                            </span>
                        </span>
                        <span className="text-[8px]">
                            Click an invoice to see full details.
                        </span>
                    </div>
                </div>

                {/* Table + Filters */}
                <FiltersPagination
                    showFilters={true}
                    filters={filters}
                    setFilters={setFilters}
                    meta={meta}
                    statusModel={"Payment"}
                >
                    <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm overflow-hidden">
                        <DataTableElement
                            columns={cols}
                            items={data}
                            tableLoad={tableLoad}
                        />
                    </div>
                </FiltersPagination>
            </div>
        </div>
    );
};

export default Accounting;
